export enum AccountHolder {
    Customer,
    User
}


// WEBPACK FOOTER //
// ./src/app/models/AccountHolder.ts